export default {
  getValueInAttributesFromPerson({ Attributes }, featureName) {
    if (Attributes) {
      return this.getValueInAttribute(Attributes.find((x) => x.FeatureName.toUpperCase().includes(featureName.toUpperCase())));
    }
  },

  // Receives field
  getValueInAttribute(attribute) {
    if (attribute !== null && attribute !== undefined) {
      if (attribute.IntegerValue !== null) {
        return attribute.IntegerValue;
      } else if (attribute.DecimalValue !== null) {
        return attribute.DecimalValue;
      } else if (attribute.StringValue !== null) {
        return attribute.StringValue;
      } else if (attribute.DateValue !== null) {
        return attribute.DateString || attribute.DateValue;
      } else if (attribute.BoolValue !== null) {
        return attribute.BoolValue;
      }
    } else {
      return null;
    }
  },

  /* Set form values in persona Model */
  setFormValuesInPersona(form, attributes, persona) {
    let personaChanges = {};
    if (persona) {
      const { RowId } = persona;
      personaChanges = {
        RowId,
        attributes: [],
        IsDeleted: false,
      };
    } else {
      personaChanges = {
        attributes: [],
        IsDeleted: false,
      };
    }

    form?.forEach((control) => control.Editable && this.setValueInPersona(attributes, persona, personaChanges, control));

    personaChanges.isActive = !!personaChanges.isActive;
    return personaChanges;
  },

  /* Set values in persona Model */
  setValueInPersona(attributes, persona, personaChanges, { InternalField, FieldDataType, Value }) {
    const attMaster = attributes.find((att) => att.FeatureName === InternalField);
    if (!attMaster || !attMaster?.AttID) {
      personaChanges[InternalField] = Value;
    } else {
      const dataTypeMapping = {
        bool: 'BoolValue',
        datetime: 'DateValue',
        decimal: 'DecimalValue',
        int: 'IntegerValue',
        string: 'StringValue',
      };
      const dataType = dataTypeMapping[FieldDataType];

      const attr = {
        AttrRowId: persona?.Attributes.find((att) => att.FeatureName === InternalField)?.AttrRowId || null,
        AttId: attMaster.AttID,
        FeatureName: InternalField,
        [dataType]: Value,
      };
      personaChanges.attributes.push(attr);
    }
  },
};
